import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { imageUrl } from '../lib/images';

export default function SpecialopgaverPage() {
  const alpinePhotos = [
    'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/131394-billede1-cropresize-375x281.webp',
    'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/171330-billede2-cropresize-375x281.webp',
    'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/158834-billede3-cropresize-375x281.webp',
    'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/194090-billede4-cropresize-375x281.webp',
    'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/133087-billede5-cropresize-375x281.webp',
  ];

  return (
    <>
      <SeoHead
        title="Specialopgaver i glasfiber - RB Glasfiber A/S"
        description="RB Glasfiber løser mange former for specialopgaver i glasfiber, stål, plast og træ. Se bl.a. terrorsikring, trappe til svømmehal og reparation af Renault Alpine 310."
        canonical="https://www.rb-glasfiber.dk/rb-glasfiber/specialopgaver"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/lasfiber-specialopgave-glasfiber-arla-mega-maelkekaton-2-cropresize-375x563.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/lasfiber-specialopgave-glasfiber-arla-mega-maelkekaton-2-cropresize-375x563.webp', 'width=1600,quality=80,format=auto')}
            alt="Specialopgaver i glasfiber"
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-shapes"></i>
              <span>Unikke løsninger & Formbygning</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              Specialopgaver i glasfiber
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Står du med en ide til en speciel opgave – så hjælper vi dig gerne videre. Vi har gennem årene udført diverse opgaver i både stål, plast, træ og glasfiber, alt efter kundens ønsker.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-sm shadow transition-all"
              >
                <span>Få vurderet din specialopgave</span>
                <i className="fa-solid fa-arrow-right text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Specialopgaver Content */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* Methods and Intro */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Løser mange former for specialopgaver
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Fra idé til færdigt emne i glasfiber
              </h2>
              <div className="prose text-slate-700 text-base leading-relaxed space-y-4">
                <p>
                  Står du med en ide til en speciel opgave – så hjælper vi dig gerne videre. Vi har gennem årene udført diverse opgaver i både stål, plast, træ og glasfiber, alt efter kundens ønsker. Se f.eks. vores mælkekarton i glasfiber til Arla, vores fiskekutter med Domino undergrundscontainere til Ringkøbing-Skjern Kommune og vores ”UFO” i glasfiber til beskyttelse af måleudstyr i rensningsanlæg. Derudover laver vi også formbygning.
                </p>
                <p>
                  I samarbejde med Rockwool producerer vi også Commercial Barriers, som er terrorsikring i form af tunge glasfiberbeholdere. Disse bruges f.eks. ved festivalindgange eller andre store arrangementer, hvor mange mennesker er samlet.
                </p>
                <p>
                  Herudover producerer vi også mandskabskurve.
                </p>
              </div>

              {/* Methods list */}
              <div className="p-5 rounded-lg bg-slate-50 border border-slate-200 space-y-2">
                <div className="font-bold text-slate-900 text-sm uppercase tracking-wide">
                  Vi udfører specialopgaver med følgende metoder:
                </div>
                <ul className="space-y-1.5 text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Støbning med håndoplæg</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Foliestøbning</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Støbning i dobbelt forme</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[3/4] bg-slate-900 max-w-sm mx-auto">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/lasfiber-specialopgave-glasfiber-arla-mega-maelkekaton-2-cropresize-375x563.webp', 'width=600,quality=85,format=auto')}
                  alt="Mega mælkekarton til Arla"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-center text-xs text-slate-500 mt-2">Mælkekarton til Arla</p>
            </div>
          </div>

          {/* SPOTLIGHT: Rep. af en Renault Alpine 310 */}
          <div className="p-8 sm:p-10 rounded-2xl bg-slate-950 text-white border border-slate-800 space-y-6">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-2">
                  <i className="fa-solid fa-car"></i>
                  <span>Specialreparation på klassiske biler</span>
                </div>
                <h3 className="text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white">
                  Rep. af en Renault Alpine 310
                </h3>
              </div>
              <Link
                to="/kontakt"
                className="px-5 py-2.5 rounded bg-[#1e9457] hover:bg-[#15703f] text-white text-xs font-bold uppercase tracking-wider transition-colors inline-flex items-center gap-2 flex-shrink-0"
              >
                <span>Forespørg på bilreparation</span>
                <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>

            <p className="text-slate-300 text-sm sm:text-base leading-relaxed max-w-3xl">
              Glasfiberkarosserier på ældre racerbiler og klassiske sportsvogne kræver særlig ekspertise for at bevare bilens oprindelige styrke, geometri og linjer. Her ses trinvis dokumentation for reparation af glasfiberkarosseriet på en klassisk Renault Alpine 310.
            </p>

            {/* Alpine Photos Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 pt-2">
              {alpinePhotos.map((src, i) => (
                <div key={i} className="group relative aspect-[4/3] rounded-lg overflow-hidden border border-slate-800 bg-slate-900">
                  <img
                    src={imageUrl(src, 'width=400,quality=85,format=auto')}
                    alt={`Renault Alpine 310 reparation trin ${i + 1}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-2 left-2 px-1.5 py-0.5 rounded bg-slate-950/80 text-[10px] font-mono text-slate-300">
                    Trin {i + 1}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Full Lightbox Gallery */}
          <div className="pt-8 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="specialopgaver"
              title="Fotogalleri: Dokumenterede specialprojekter"
              description="Udforsk flere eksempler på formbygning, terrorsikring, svømmehalstrapper og kundetilpassede kompositløsninger."
              columns={3}
            />
          </div>
        </div>
      </section>
    </>
  );
}
